import { Link } from "react-router";
import { Phone, Mail, MapPin, Facebook, Twitter, Instagram, Linkedin, Youtube, Wind, Flame, Snowflake, Zap, FlaskConical, Users, Settings, FileSearch, Headphones } from "lucide-react";
import solaceLogo from "../../assets/Solacesmartlogo.webp";

export function Footer() {
  return (
    <footer className="bg-[#0f1b30] text-white">
      {/* Main Footer */}
      <div className="max-w-screen-2xl mx-auto px-6 pt-16 pb-8">
        {/* Using a 5-column grid where the first column takes 2 slots (40%) and the others take 1 slot (20% each) to perfectly balance the space */}
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-12">
          {/* Brand & Contact */}
          <div className="lg:col-span-2 lg:pl-8">
            <Link to="/" className="inline-block mb-4">
              <img src={solaceLogo} alt="Solace Smart Solutions" className="h-16 w-auto object-contain rounded-[8px]" />
            </Link>
            <p className="text-white/75 text-sm mb-6 pr-4" style={{ lineHeight: 1.8 }}>
              Bound To Provide SOLACE For Professionals With<br />SMART Methodologies To Deliver the Utmost Solutions.
            </p>

            {/* Contact Details moved here */}
            <ul className="space-y-4 mb-6">
              <li>
                <a href="tel:+918800878095" className="flex items-start gap-3 text-white/75 hover:text-[#E9A319] transition-colors text-sm">
                  <Phone className="w-4 h-4 mt-0.5 shrink-0" />
                  <span>+91 88008-78095<br />+91 88755-55358</span>
                </a>
              </li>
              <li>
                <a href="mailto:Connect@Solacesmart.com" className="flex items-center gap-3 text-white/75 hover:text-[#E9A319] transition-colors text-sm">
                  <Mail className="w-4 h-4 shrink-0" />
                  <span>Connect@Solacesmart.com</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/75 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-[#E9A319]" />
                <div className="space-y-2">
                  <p><span className="text-white/90 font-semibold">Rajasthan:</span><br />B12, Pratap Plaza, Pratap Nagar, Jaipur</p>
                </div>
              </li>
            </ul>

          </div>

          {/* Services */}
          <div>
            <h4 className="text-white text-sm tracking-widest uppercase mb-5" style={{ fontWeight: 700 }}>Services</h4>
            <ul className="space-y-3">
              {[
                { label: "HVAC Projects", path: "/services/hvac", icon: Wind },
                { label: "Heat Pump Water Heater", path: "/services/heat-pump", icon: Flame },
                { label: "Refrigeration & Cold Room", path: "/services/refrigeration", icon: Snowflake },
                { label: "Electrical Panel & PLC", path: "/services/electrical", icon: Zap },
                { label: "Refrigerant ISO Tank System", path: "/services/refrigerant", icon: FlaskConical },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/75 text-sm hover:text-[#E9A319] transition-colors flex items-center gap-2.5"
                  >
                    <link.icon className="w-3.5 h-3.5 shrink-0" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-white text-sm tracking-widest uppercase mb-5" style={{ fontWeight: 700 }}>Products</h4>
            <ul className="space-y-3">
              {[
                { label: "HVAC Systems", path: "/products", icon: Wind },
                { label: "Heat Pumps", path: "/products", icon: Flame },
                { label: "Refrigeration", path: "/products", icon: Snowflake },
                { label: "Electrical Panels", path: "/products", icon: Zap },
                { label: "ISO Tank Systems", path: "/products", icon: FlaskConical },
              ].map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-white/75 text-sm hover:text-[#E9A319] transition-colors flex items-center gap-2.5"
                  >
                    <link.icon className="w-3.5 h-3.5 shrink-0" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white text-sm tracking-widest uppercase mb-5" style={{ fontWeight: 700 }}>Company</h4>
            <ul className="space-y-3">
              {[
                { label: "About Us", path: "/about", icon: Users },
                { label: "Our Services", path: "/services", icon: Settings },
                { label: "Our Projects", path: "/projects", icon: FileSearch },
                { label: "Blog", path: "/blog", icon: FileSearch },
                { label: "Contact Us", path: "/contact", icon: Headphones },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/75 text-sm hover:text-[#E9A319] transition-colors flex items-center gap-2.5"
                  >
                    <link.icon className="w-3.5 h-3.5 shrink-0" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>

            {/* Social Media moved here */}
            <div className="mt-8">
              <span className="text-white/80 text-xs font-semibold uppercase tracking-wider mb-4 block">Follow Us</span>
              <div className="flex gap-3">
                {[
                  { icon: Facebook, href: "https://www.facebook.com/profile.php?id=100090510362699", label: "Facebook" },
                  { icon: Twitter, href: "https://twitter.com/Solace_SMART", label: "Twitter" },
                  { icon: Instagram, href: "https://www.instagram.com/solacesmartsolutions/", label: "Instagram" },
                  { icon: Linkedin, href: "https://www.linkedin.com/company/solace-smart-solution/", label: "LinkedIn" }
                ].map(({ icon: Icon, href, label }) => (
                  <a
                    key={href + label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    className="w-9 h-9 border border-white/30 rounded-full flex items-center justify-center text-white/75 hover:bg-[#E9A319] hover:text-white hover:border-[#E9A319] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_4px_12px_rgba(233,163,25,0.3)]"
                  >
                    <Icon className="w-4 h-4 shrink-0" />
                  </a>
                ))}
              </div>
            </div>
          </div>


        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-screen-2xl mx-auto px-6 py-5 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-white/75 text-sm flex flex-col sm:flex-row items-center gap-2 sm:gap-4 text-center sm:text-left">
            <span>&copy; {new Date().getFullYear()} Solace SMART Solutions. All rights reserved.</span>
            <span className="hidden sm:inline text-white/50">|</span>
            <span className="flex items-center gap-1.5">
              Designed & Developed by
              <a href="https://webdestinexhub.com/" target="_blank" rel="noopener noreferrer" className="text-white/90 hover:text-[#E9A319] transition-colors font-semibold tracking-wide">
                Web destineX Hub
              </a>
            </span>
          </div>
          <div className="text-white/80 text-sm flex flex-wrap justify-center md:justify-end gap-x-6 gap-y-2">
            <Link to="/privacy-policy" className="hover:text-[#E9A319] transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-[#E9A319] transition-colors">Terms & Conditions</Link>
            <Link to="/sitemap" className="hover:text-[#E9A319] transition-colors">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
